const text = (value) => String(value ?? '').trim()

const byPosition = (one, other) => Number(one.position ?? 0) - Number(other.position ?? 0)

const labelled = (detail) => {
    const name = text(detail.name)
    const value = text(detail.value)

    return name === '' ? value : `${name}: ${value}`
}

export function resolveCompanyOptions(companies) {
    return (companies ?? [])
        .map((company) => ({
            id: company.id,
            label: text(company.companyName),
        }))
        .sort((one, other) => one.label.localeCompare(other.label))
}

// The marketing flag is what says an address may receive promotional mail. Which
// addresses carry it is settled where consent is recorded, not here.
export function resolveRecipientOptions(details) {
    return (details ?? [])
        .filter((detail) => detail.type === 'email')
        .filter((detail) => (detail.flags ?? []).includes('marketing'))
        .filter((detail) => text(detail.value) !== '')
        .sort(byPosition)
        .map((detail) => ({
            id: detail.id,
            value: text(detail.value),
            label: labelled(detail),
        }))
}

export function resolveSenderNameOptions(details) {
    return (details ?? [])
        .filter((detail) => text(detail.value) !== '')
        .sort(byPosition)
        .map((detail) => ({
            id: detail.id,
            value: text(detail.value),
            label: labelled(detail),
        }))
}

export function resolveSelectedSenderDetailId(options, rememberedId) {
    const held = options.find((option) => String(option.id) === String(rememberedId))

    return held?.id ?? options[0]?.id ?? null
}

const CONTACT_TYPES = ['email', 'phone', 'whatsapp']

export function resolveShareableContactIds(details) {
    return (details ?? [])
        .filter((detail) => CONTACT_TYPES.includes(detail.type))
        .filter((detail) => (detail.flags ?? []).includes('shareable'))
        .filter((detail) => text(detail.value) !== '')
        .sort(byPosition)
        .map((detail) => detail.id)
}

export function resolveChosenContactOptions(details, chosenIds) {
    return (details ?? [])
        .filter((detail) => chosenIds.includes(detail.id))
        .filter((detail) => CONTACT_TYPES.includes(detail.type))
        .filter((detail) => text(detail.value) !== '')
        .sort(byPosition)
        .map((detail) => ({
            id: detail.id,
            value: labelled(detail),
        }))
}
